export function normalizeBrCurrency(data:number){
    return `R$ ${data.toLocaleString('pt-BR')}`;
}